import type { ReactNode } from 'react';

export const symbol_rule: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m687-271-90 90q-9 9-21 9t-21-9q-9-9-9-21t9-21l90-90-90-90q-9-9-9-21t9-21q9-9 21-9t21 9l90 90 90-90q9-9 21-9t21 9q9 9 9 21t-9 21l-90 90 90 90q9 9 9 21t-9 21q-9 9-21 9t-21-9l-90-90Zm-28-348 158-158q9-9 21-8.5t21 9.5q9 9 9 21t-9 21L680-555q-9 9-21 9t-21-9L538-655q-9-9-9-21t9-21q9-9 21-8.5t21 8.5l79 78ZM110-350h300q13 0 21.5 8.5T440-320q0 13-8.5 21.5T410-290H110q-13 0-21.5-8.5T80-320q0-13 8.5-21.5T110-350Zm0-320h300q13 0 21.5 8.5T440-640q0 13-8.5 21.5T410-610H110q-13 0-21.5-8.5T80-640q0-13 8.5-21.5T110-670Z"
		/>
	</svg>
);
